import { render, staticRenderFns } from "./AddOrEditReward.vue?vue&type=template&id=cac8573c&"
import script from "./AddOrEditReward.vue?vue&type=script&lang=js&"
export * from "./AddOrEditReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports